<template>
    <v-layout column>

        <v-layout class="big-toolbar" justify-start align-center column>
                <span class="header"><strong>App Estratégia</strong></span>
                <v-card class="content">
                    <v-layout column justify center>
                        <span class="title">
                            Página não encontrada
                        </span>
                        <v-layout mt-4 justify-center>
                            <v-btn color="teal" flat :to="{path: '/dashboard'}">
                                Página principal
                            </v-btn>
                        </v-layout>
                    </v-layout>
                </v-card>
        </v-layout>
    </v-layout>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
    .big-toolbar{
        z-index: 3;
        background: linear-gradient(to right, #eef2f3, #8e9eab);

        .header {
            font-size: 24px;
            padding: 10px;
            font-weight: 300;

            strong {
                font-weight: 500;
            }
        }

    }
    .content {
        display: flex;
        padding: 20px;
        width: 50%;
        min-height: 200px;

        .title {
            font-size: 22px !important;
            font-weight: 500;
            margin: 0 auto;
        }

        .content {
            font-size: 18px;
            margin: auto;
        }

    }

    .highligth {
        color: #12c19c;
    }
</style>
